export default __webpack_public_path__ + "static/media/167.59b1a979.svg";